/** Take a react node, and wrap it in something with a tooltip that says "Copy ..."" */

import { ReactElement } from "react";
import { Tooltip } from "./arbiter-components/tooltip/tooltip";
import * as copyableTooltipCss from "./copyable-tooltip.module.css";

/** undefined = no truncation */
export const TRUNCATE_COPYABLE_TEXT_PREVIEW_LENGTH: number | undefined =
  undefined;

/** Doesn't provide functionality of click events; just a standard message & tooltip. */
export const CopyableTooltip = ({
  children,
  textToCopy,
  placement = "top",
  open,
}: {
  children: ReactElement;
  textToCopy: string;
  placement?: Parameters<typeof Tooltip>[0]["placement"];
  /**
   * Controls visibility. When set, hovering no longer opens the tooltip — only
   * the caller does, e.g. to show "Copied!" on click without a hover hint.
   */
  open?: boolean;
}) => {
  const truncatedText = TRUNCATE_COPYABLE_TEXT_PREVIEW_LENGTH
    ? textToCopy.slice(0, TRUNCATE_COPYABLE_TEXT_PREVIEW_LENGTH)
    : textToCopy;
  return (
    <Tooltip
      placement={placement}
      title={`${truncatedText}${
        textToCopy.length > truncatedText.length ? "..." : ""
      }`}
      {...(open === undefined
        ? {}
        : {
            open,
            disableFocusListener: true,
            disableHoverListener: true,
            disableTouchListener: true,
          })}
    >
      <span
        className={copyableTooltipCss.copyableItem}
        data-web="CopyableTooltip"
      >
        {children}
      </span>
    </Tooltip>
  );
};
